import React, { useMemo } from 'react';
import { DatePickerV2 } from './DatePickerV2';
import { constraintDayPickerMatcher, constraintNot, constraintTrue } from './constraints';
import { addMilliseconds } from 'date-fns';
import { DateMultiPickerProps } from '../types';

export type { DateMultiPickerProps };

/**
 * DatePickerV2를 DateMultiPicker와 동일한 props로 호환시키기 위한 컴포넌트입니다.
 */
export const DateMultiPickerCompat: React.FC<DateMultiPickerProps> = ({
  width,
  flex,
  size,
  status,
  disabled,
  className,
  placeholder,
  hasRemoveButton,
  zIndex,
  displayMode,
  numberOfMonths,
  dates,
  disabledDays,
  onChange,
  onOpen,
  onClose,
}) => {
  const constraint = useMemo(() => {
    if (!disabledDays) {
      return constraintTrue();
    }
    return constraintNot(constraintDayPickerMatcher(disabledDays));
  }, [disabledDays]);

  const value = useMemo(() => {
    if (!dates?.length) {
      return [];
    }

    return dates.map((date, index) => ({
      id: `${date.valueOf()}-${index}`,
      from: date,
      to: addMilliseconds(date, 1),
    }));
  }, [dates]);

  return (
    <DatePickerV2
      width={width}
      flex={flex}
      size={size}
      status={status}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      hasRemoveButton={hasRemoveButton}
      zIndex={zIndex}
      displayMode={displayMode}
      numberOfMonths={numberOfMonths}
      hasTodayButton={false}
      unit='day'
      target='all'
      multiple
      value={value}
      constraint={constraint}
      onOpen={onOpen}
      onClose={onClose}
      onChange={(items) => {
        onChange?.(items.map((item) => item.from));
      }}
    />
  );
};
